// extracted by mini-css-extract-plugin
export default {"timezoneNote":"channel-history_timezoneNote_ZKYIE"};